import { SETTINGS_KEYS } from '../config/environment'
import { Correspondent, Document, DocumentType, SavedView, StoragePath, Tag } from '../types'
import { apiService } from './api.service'
import { settingsService } from './settings.service'

export interface GlobalSearchResult {
  total: number
  documents: Document[]
  saved_views: SavedView[]
  correspondents: Correspondent[]
  document_types: DocumentType[]
  storage_paths: StoragePath[]
  tags: Tag[]
  users: any[]
  groups: any[]
  mail_accounts: any[]
  mail_rules: any[]
  custom_fields: any[]
  workflows: any[]
}

class SearchService {
  public readonly searchResultObjectLimit: number = 3

  async autocomplete(term: string): Promise<string[]> {
    const response = await apiService.get<string[]>('search/autocomplete/', {
      params: { term },
    })
    return response.data
  }

  async globalSearch(query: string): Promise<GlobalSearchResult> {
    const params: any = { query }

    // Check if advanced search should be excluded (SEARCH_DB_ONLY setting)
    const searchDbOnly = settingsService.get(SETTINGS_KEYS.SEARCH_DB_ONLY)
    if (searchDbOnly) {
      params.db_only = true
    }

    const response = await apiService.get<GlobalSearchResult>('search/', {
      params,
    })
    return response.data
  }

  get searchDbOnly(): boolean {
    return settingsService.get(SETTINGS_KEYS.SEARCH_DB_ONLY) || false
  }
}

export const searchService = new SearchService()
